/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Button,
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
  Box,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import ContractTable from '../../../components/form/Table/ContractTable';
import { getDetailContractsAction, getHistoryConsumptionDataDashboardAction } from '../../../actions/license.action';

const getMulishText = (fontWeight, color) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize: '14px',
  fontWeight,
  color,
});

const useStyles = makeStyles(() => ({
  tableHead: {
    backgroundColor: '#009BDD',
    borderTopRightRadius: '5px',
  },
  tableHeadItem: {
    ...getMulishText(700, 'white'),
  },
  infoText: {
    ...getMulishText(700, '#000000'),
    fontSize: '19px',
    paddingLeft: '5%',
  },
  tableContainer: {
    paddingTop: '25px',
  },
  button: {
    backgroundColor: '#E55200',
    paddingLeft: '19px',
    paddingRight: '19px',
    paddingBottom: '8px',
    paddingTop: '8px',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#E55200',
    },
  },
  textButton: {
    ...getMulishText(700, 'white'),
  },
  circularProgressTotal: {
    color: '#009BDD',
  },
  circularProgressAvailable: {
    color: '#009838',
  },
  circularProgressUsed: {
    color: '#F1C21B',
  },
}));

/**
 * View into products, show a detail of use contracts
 * @param {*} props
 * @returns
 */
const DetailContract = (props) => {
  const classes = useStyles();
  const {
    ServiceName, PackageCode, getDetailContracts, detailContracts, userInfo, RequiresSupervision, history, getHistoryConsumptionDataDashboard, TotalDashboardDaysRange, customer
  } = props;
  const columnData = [
    {
      id: 'contractNumber',
      label: 'Contrato',
      minWidth: 100,
      position: 1,
      isSortable: true,
      sortPropertyName: 'contractNumber',
    },
    {
      id: 'contractStartDate',
      label: 'Fecha inicio',
      minWidth: 100,
      position: 2,
      isSortable: true,
      sortPropertyName: 'contractStartDate',
    },
    {
      id: 'contractEndDate',
      label: 'Fecha vencimiento',
      minWidth: 100,
      position: 3,
      isSortable: true,
      sortPropertyName: 'contractEndDate',
    },
    {
      id: 'totalAmmount',
      label: 'Total',
      minWidth: 100,
      position: 4,
      isSortable: true,
      sortPropertyName: 'totalAmmount',
    },
    {
      id: 'totalBalance',
      label: 'Disponibles',
      minWidth: 100,
      position: 5,
      isSortable: true,
      sortPropertyName: 'totalBalance',
    },
    {
      id: 'totalUsed',
      label: 'Usados',
      minWidth: 100,
      position: 6,
      isSortable: true,
      sortPropertyName: 'totalUsed',
    },
    {
      id: 'actions',
      label: '',
      align: 'center',
      isSortable: false,
      width: '100px',
    },
  ];
  const [contracts, setContracts] = useState([]);
  const [contractInfo, setContractInfo] = useState({});
  const [loading, setLoading] = useState(true);
  /**
   * Add dot to a number for example 3000 --> 3.000
   * @param {*} number simple number
   * @returns format number
   */
  const formatNumber = (number) => {
    const exp = /(\d)(?=(\d{3})+(?!\d))/g;
    const rep = '$1.';
    return number.toString().replace(exp, rep);
  };

  const loadData = (data) => {
    setContractInfo({
      quantityAccumulated: formatNumber(data?.quantityAccumulated),
      balanceAccumulated: formatNumber(data?.balanceAccumulated),
      usedAccumulated: formatNumber(data?.usedAccumulated),
      isUnlimited: data.isUnlimited,
      serviceFeatureCode: data.serviceFeatureCode,
    });
    const updatedContracts = data.contractServiceDetail?.map(
      (item) => ({
        ...item,
        contractStartDate: item.effectiveDate
          ? new Date(item.effectiveDate).toLocaleDateString('es-ES')
          : '',
        contractEndDate: item.expirationDate
          ? new Date(item.expirationDate).toLocaleDateString('es-ES')
          : '',
        totalAmmount: item.isUnlimited ? 'Ilimitado' : formatNumber(item.totalAmmount),
        totalBalance: item.isUnlimited ? 'Ilimitado' : formatNumber(item.totalBalance),
        totalUsed: formatNumber(item.totalUsed),
        state: 0,
      }),
    );
    setContracts(updatedContracts);
  };

  const handleClickMovements = () => {
    const dateStart = moment().subtract(TotalDashboardDaysRange, 'days').format('YYYY-MM-DD');
    const dateFinal = moment().format('YYYY-MM-DD');

    const documentType = customer?.documentType != null ? customer?.documentType : userInfo?.customer_type; 
    const documentNumber = customer?.documentNumber != null ? customer?.documentNumber : userInfo?.customer_value;

    const data = {
      documentType: documentType,
      documentNumber: documentNumber,
      serviceName: ServiceName,
      serviceFeatureCode: contractInfo?.serviceFeatureCode,
      startDate: dateStart,
      endDate: dateFinal,
      isSupervised: RequiresSupervision,
    };
    getHistoryConsumptionDataDashboard(data, history, undefined, 0, 100, TotalDashboardDaysRange);
  };

  /**
   * get used acumulated only for limited contracts
   */
  const getUsedAcumulated = () => {
    let sum = 0;
    contracts.forEach((contract) => {
      if (!contract.isUnlimited) {
        sum += Number(contract.totalUsed.replace(/\./g, ''));
      }
    });
    return sum.toString();
  };

  const valuePercentage = (value, total, isUnlimited) => {
    if (isUnlimited) return 100;
    return (((Number(value.replace(/\./g, '')) / Number(total.replace(/\./g, ''))) * 100).toFixed(1)).replace(/\.0$/, '');
  };

  function CircularProgressWithPercentage({
    value, size = 75, thickness = 4, className,
  }) {
    // Porcentaje=( Total/Parte ) × 100
    const numericValue = Number(value);
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress
          variant="determinate"
          value={100}
          size={size}
          thickness={thickness}
          style={{
            color: '#E0E0E0',
            position: 'absolute',
            left: 0,
          }}
        />
        <CircularProgress
          variant="determinate"
          value={numericValue}
          size={size}
          thickness={thickness}
          className={className}
        />
        <Box
          position="absolute"
          top={0}
          left={0}
          bottom={0}
          right={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography
            component="div"
            style={{
              fontSize: '15px',
              color: '#262626',
              transform: 'translateY(1px)',
            }}
          >
            {`${(value)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }

  useEffect(() => {
    if (detailContracts && detailContracts.length > 0) {
      const index = detailContracts.findIndex(
        (item) => item.contractPackageId === `${ServiceName}-${PackageCode}-${RequiresSupervision}`,
      );
      const currentContract = detailContracts[index];
      if (currentContract) {
        setLoading(false);
        loadData(currentContract);
      }
    }
    // eslint-disable-next-line
  }, [detailContracts, ServiceName, PackageCode]);

  useEffect(() => {
    setLoading(true);
    getDetailContracts(ServiceName, PackageCode, RequiresSupervision, customer);
  }, [ServiceName, PackageCode, getDetailContracts, RequiresSupervision, customer]);

  return (
    <>
      {(loading) ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div style={{ padding: '20px' }}>
          <Grid container sx={{ minHeight: '100vh', padding: 2 }}>
            <Grid item xs={4}>
              <Box display="flex" alignItems="center">
                <CircularProgressWithPercentage className={classes.circularProgressTotal} value={100} />
                <Typography component="div" className={classes.infoText}>
                  { contractInfo?.isUnlimited ? 'Ilimitado' : contractInfo?.quantityAccumulated}
                  <br />
                  <div style={{ color: '#000000', fontWeight: 400, fontSize: '16px' }}>
                    Total
                  </div>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box display="flex" alignItems="center">
                <CircularProgressWithPercentage className={classes.circularProgressAvailable} value={valuePercentage(contractInfo?.balanceAccumulated, contractInfo?.quantityAccumulated, contractInfo?.isUnlimited)} />
                <Typography component="div" className={classes.infoText}>
                  { contractInfo?.isUnlimited ? 'Ilimitado' : contractInfo?.balanceAccumulated}
                  <br />
                  <div style={{ color: '#000000', fontWeight: 400, fontSize: '16px' }}>
                    Disponible
                  </div>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={2}>
              <Box display="flex" alignItems="center">
                <CircularProgressWithPercentage className={classes.circularProgressUsed} value={valuePercentage(getUsedAcumulated(), contractInfo?.quantityAccumulated, contractInfo?.isUnlimited)} />
                <Typography component="div" className={classes.infoText}>
                  {contractInfo?.usedAccumulated}
                  <br />
                  <div style={{ color: '#000000', fontWeight: 400, fontSize: '16px' }}>
                    Usado
                  </div>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={2} style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ paddingLeft: '25%' }}>
                <Button className={classes.button} onClick={handleClickMovements}>
                  <Typography className={classes.textButton}>
                    Movimientos
                  </Typography>
                </Button>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.tableContainer}>
              <ContractTable
                columns={columnData}
                data={contracts}
                enablePagination={false}
                styleTableContainer={{ marginTop: '15px', width: 'auto' }}
                styleTableCell={{
                  ...getMulishText(400, '#000000'),
                  textAlign: 'left',
                }}
                styleTableHead={{ textAlign: 'left' }}
                history={history}
              />
            </Grid>
          </Grid>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (props) => ({
  getDetailContracts: props.license.getDetailContracts,
  detailContracts: props.license.detailContracts,
  userInfo: props.auth.userInfo,
});

const mapDispatchToProps = {
  getDetailContracts: getDetailContractsAction,
  getHistoryConsumptionDataDashboard: getHistoryConsumptionDataDashboardAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailContract);
